/**
 * Métadonnées visuelles des verticales (code, couleur, illustration, path).
 * Les labels FR/EN + descriptions sont dans /lib/i18n/{fr,en}.js sous `verticals.<code>`.
 */
export const VERTICALS = [
  {
    code: 'sante',
    color: '#10B981',
    glow: 'rgba(16, 185, 129, 0.45)',
    tint: 'rgba(16, 185, 129, 0.10)',
    illustration: '/brand/capsule-sante.png',
    path: '/univers/sante',
  },
  {
    code: 'culture',
    color: '#8B5CF6',
    glow: 'rgba(139, 92, 246, 0.45)',
    tint: 'rgba(139, 92, 246, 0.10)',
    illustration: '/brand/capsule-culture.png',
    path: '/univers/culture',
  },
  {
    code: 'formation',
    color: '#0EA5E9',
    glow: 'rgba(14, 165, 233, 0.45)',
    tint: 'rgba(14, 165, 233, 0.10)',
    illustration: '/brand/capsule-formation.png',
    path: '/univers/formation',
  },
  {
    code: 'langues',
    color: '#F43F5E',
    glow: 'rgba(244, 63, 94, 0.45)',
    tint: 'rgba(244, 63, 94, 0.10)',
    illustration: '/brand/capsule-langues.png',
    path: '/univers/langues',
  },
  {
    code: 'social',
    color: '#F97316',
    glow: 'rgba(249, 115, 22, 0.45)',
    tint: 'rgba(249, 115, 22, 0.10)',
    illustration: '/brand/capsule-social.png',
    path: '/univers/social',
  },
];

export const VERTICALS_BY_CODE = Object.fromEntries(VERTICALS.map((v) => [v.code, v]));

/**
 * Helper : enrichit une verticale avec ses libellés traduits.
 * `raw` vient du hook useRaw(). Retourne label, short, tagline, description, promise, intro, use_cases.
 */
export function verticalCopy(raw, code) {
  const v = VERTICALS_BY_CODE[code];
  if (!v) return null;
  const dict = raw(`verticals.${code}`) || {};
  return {
    ...v,
    label: dict.label || code,
    short: dict.short || code,
    tagline: dict.tagline || '',
    description: dict.description || '',
    promise: dict.promise || '',
    intro: dict.intro || '',
    use_cases: dict.use_cases || [],
  };
}
